function Form() {
	this.init();
}

Form.prototype.init = function () {
	$('form.ajax').submit( function(e) {
		e.preventDefault();
		var f = $(e.target);
		$.ajax({
			type: 'POST',
			url: f.attr('action'),
			data: f.serialize(),
			dataType: 'json',
			success: function (data) {
				if (data.status===0) {
					//walidacja formularza	
					$('p.error').empty();
					if ($('form.ajax input[type="checkbox"]:checked').length === 0 || !$('form.ajax input[type="email"]').val()) {
						if (!$('p.error').hasClass('-visible')) {
							$('p.error').addClass('-visible');
						}
						if (!$('form.ajax input[type="email"]').val()) {
							$('p.error').append('<p>Enter your email address!</p>');
							if (!$('form.ajax input[type="email"]').hasClass('input-error')) {
								$('form.ajax input[type="email"]').addClass('input-error');
							}
						}
						if ($('form.ajax input[type="checkbox"]:checked').length === 0) {
							$('p.error').append('<p>Select at least one option!</p>');
							if (!$('form.ajax input[type="checkbox"] + span').hasClass('checkbox-error')) {
								$('form.ajax input[type="checkbox"] + span').addClass('checkbox-error');
							}
						} else {
							if ($('form.ajax input[type="checkbox"] + span').hasClass('checkbox-error')) {
								$('form.ajax input[type="checkbox"] + span').removeClass('checkbox-error');
							}
						}
					} else {
						if (data.code.email) {
							if (!$('form.ajax input[type="email"]').hasClass('input-error')) {
								$('form.ajax input[type="email"]').addClass('input-error');
							}
							if (!$('p.error').hasClass('-visible')) {
								$('p.error').addClass('-visible');
							}
							$('p.error').append('<p>'+data.code.email+'</p>');
						} else {
							$('form.ajax input[type="email"]').removeClass('input-error');
						}
						$('form.ajax input[type="checkbox"] + span').removeClass('checkbox-error');
					}
				}
				else if (data.status==1) {
					$('body').addClass('-transition');
					setTimeout(function() {
						window.location.href = data.redirect;
					}, 500);
				}
			}
		});
	});
};

$(document).ready(function(){
	form = new Form();
});